import React from 'react';
import { Option } from 'react-dropdown';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
	AnimalKind,
	IMoveToPregnancyLocation,
	DefaultFeedCurve,
	ESFReader,
	IWorkListSetting,
	MoveToLocationTypes,
	MoveToPregnancyLocation,
	WorkListType,
	Equipment,
} from 'shared/api/api';
import { ExceptionMessage } from 'shared/helpers/exception-message';
import { generateFeedCurveOptionsWithLocationCode } from 'shared/helpers/feed-curve-helper';
import { deepCopy } from 'shared/helpers/general-helpers';
import { ESFReaderOptions } from 'shared/helpers/work-list-helpers/esf-list-helpers/generel-esf-list-helper';
import {
	GetMoveToOptions,
	ResetDataOnMoveListSetups,
} from 'shared/helpers/work-list-helpers/move-to-helpers/moving-lists-helper';
import { SaveWorkListSetting } from 'shared/state/ducks/work-list-settings/operations';
import { localized } from 'shared/state/i18n/i18n';
import { WebAppState } from 'web/state/store.web';
import { ViewWeb } from 'web/view/components/utils/web-view';
import { TextWeb } from 'web/web-helpers/styled-text-components';
import { showAlert } from '../../skiold-alert/skiold-alert';
import { SkioldButton } from '../../skiold-components/skiold-button/skiold-button';
import { SkioldCheckbox } from '../../skiold-components/skiold-checkbox/skiold-checkbox';
import { SkioldFormDropdown } from '../../skiold-components/skiold-dropdown/skiold-form-dropdown';
import { SkioldFormsWrapper } from '../../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper';
import { FormRow } from '../../skiold-components/skiold-forms-wrapper/skiold-forms-wrapper-types';
import { SkioldFormIntegerInput } from '../../skiold-components/skiold-integer-input/skiold-form-integer-input';
import '../list-setup.scss';
import { getAvailablityRow, getSkioldInputRow } from '../work-list-helper';
import './move-to-pregnant-setup.scss';
import { filterElistarFeedCurvesByAnimalKind } from 'shared/helpers/elistar-feed-curve-helper';

interface PropsFromParent {
	workListType: WorkListType;
}

const mapStateToProps = (state: WebAppState) => {
	return {
		useEsf: state.processEquipments.entities.find(e => e.equipment === Equipment.ESF),
		useElistar: state.processEquipments.entities.find(e => e.equipment === Equipment.Elistar),
		workListSettings: state.workListSettings.entities,
		siteId: state.profile.active!.siteId,
		// feedCurves: state.site.site.feedCurves,
		feedCurvesOptions: generateFeedCurveOptionsWithLocationCode(state.esfStatus.availableCurves),
	};
};

const mapDispatchToProps = (dispatch: Dispatch, props: {}) => ({
	saveWorkListSetting: (movetoPregnancySetup: IMoveToPregnancyLocation) =>
		SaveWorkListSetting(movetoPregnancySetup)(dispatch),
});

export interface MoveToPregnantSetupState {
	movetoPregSetup: IMoveToPregnancyLocation;
	selectedOption: Option;
	options: Option[];
	// selectedFeedCurve: Option;
	// feedCurves: Option[];
}

type MoveToPregnantSetupProps = ReturnType<typeof mapStateToProps> &
	ReturnType<typeof mapDispatchToProps> &
	PropsFromParent;
class MoveToPregnantSetup extends React.PureComponent<MoveToPregnantSetupProps, MoveToPregnantSetupState> {
	constructor(props: MoveToPregnantSetupProps) {
		super(props);
		this.state = {
			movetoPregSetup: this.getWorkListSetting(props.workListType),
			options: GetMoveToOptions(),
			selectedOption: { label: '', value: '' },
		};
	}

	public componentDidMount() {
		let initSetting = {};
		if (this.state.movetoPregSetup.selectedType !== undefined) {
			initSetting['selectedOption'] = {
				label: localized(this.state.movetoPregSetup.selectedType),
				value: this.state.movetoPregSetup.selectedType,
			};
		}

		this.setState(initSetting);
	}

	public toggleShowOnWeb = () => {
		this.setState(prevState => ({
			movetoPregSetup: { ...prevState.movetoPregSetup, showOnWeb: !this.state.movetoPregSetup.showOnWeb },
		}));
	};

	public toggleShowOnApp = () => {
		this.setState(prevState => ({
			movetoPregSetup: { ...prevState.movetoPregSetup, showOnApp: !this.state.movetoPregSetup.showOnApp },
		}));
	};

	public moveToPregnatSetupChanged(setup: IMoveToPregnancyLocation) {
		this.setState({
			movetoPregSetup: setup,
		});
	}

	public render() {
		return (
			<ViewWeb className="move-to-pregnant-setup">
				<ViewWeb className="view-container">
					<TextWeb className="setup-header">{localized('Setup')}</TextWeb>
					<SkioldFormsWrapper formRows={this.getFormRows()} containerClassName="wrapper-container" />
					{this.renderButtons()}
				</ViewWeb>
			</ViewWeb>
		);
	}

	private save() {
		if (!this.validate(this.state.movetoPregSetup)) {
			return;
		}

		let movetoPregSetup = deepCopy(this.state.movetoPregSetup);
		movetoPregSetup.selectedType = this.state.selectedOption.value as MoveToLocationTypes;
		ResetDataOnMoveListSetups(movetoPregSetup);
		movetoPregSetup.siteId = this.props.siteId;
		this.setState({ movetoPregSetup });
		this.props.saveWorkListSetting(movetoPregSetup);
	}

	private validate(listSetting: IMoveToPregnancyLocation) {
		if (!listSetting.selectedType) {
			showAlert(localized(ExceptionMessage.VALIDATION_ERROR_CHOOSE_ANIMAL_NOT_SET));
			return false;
		}
		if (listSetting.selectedType === MoveToLocationTypes.MatingBatch) {
			if (!listSetting.batchCycleDays) {
				showAlert(localized(ExceptionMessage.VALIDATION_ERROR_CYCLEDAYS_NOT_SET));
				return false;
			}
		}
		if (listSetting.selectedType === MoveToLocationTypes.PregnacyDays) {
			if (
				listSetting.cycleDaysFrom === undefined ||
				listSetting.cycleDaysFrom === null ||
				listSetting.cycleDaysFrom < 0
			) {
				showAlert(localized(ExceptionMessage.VALIDATION_ERROR_PREGNANT_FROM_IS_EMPTY_OR_NEGATIVE));
				return false;
			}
			if (
				listSetting.cycleDaysTo === undefined ||
				listSetting.cycleDaysTo === null ||
				listSetting.cycleDaysTo < listSetting.cycleDaysFrom
			) {
				showAlert(localized(ExceptionMessage.VALIDATION_ERROR_PREGNANT_TO_IS_EMPTY_OR_NEGATIVE));
				return false;
			}
		}

		return true;
	}

	private getFormRows() {
		let formRows = new Array<FormRow>();
		formRows.push(this.getBuildingHeader());
		formRows.push(
			getSkioldInputRow(
				setup => this.moveToPregnatSetupChanged(setup),
				this.state.movetoPregSetup,
				'name',
				localized('name'),
			),
		);
		formRows.push(this.getAnimalToListRow());
		if (this.state.selectedOption.value === MoveToLocationTypes.MatingBatch) {
			formRows.push({
				name: localized('pregnantDays'),
				component: (
					<SkioldFormIntegerInput
						onChangeNumber={newNumber =>
							this.valueInMoveToPregnantSetupChanged(newNumber, 'batchCycleDays')
						}
						text={this.state.movetoPregSetup.batchCycleDays}
					/>
				),
			});
		}
		if (this.state.selectedOption.value === MoveToLocationTypes.PregnacyDays) {
			formRows.push({
				name: localized('pregnantDays'),
				component: (
					<ViewWeb className="nursing-from-to-container">
						<ViewWeb className="flex-one-row form-padding">
							<TextWeb>{localized('from')}</TextWeb>
							<SkioldFormIntegerInput
								className="days-input"
								onChangeNumber={this.cycleDaysFromDateChanged}
								text={this.state.movetoPregSetup.cycleDaysFrom}
							/>
						</ViewWeb>
						<ViewWeb className="flex-one-row">
							<TextWeb>{localized('to')}</TextWeb>
							<SkioldFormIntegerInput
								className="days-input"
								onChangeNumber={this.cycleDaysToDateChanged}
								text={this.state.movetoPregSetup.cycleDaysTo}
							/>
						</ViewWeb>
					</ViewWeb>
				),
			});
		}

		formRows.push(this.getNegativeCycleDaysRow());
		formRows.push(this.getFeedCurves());

		formRows.push(
			getAvailablityRow(
				this.toggleShowOnWeb,
				this.toggleShowOnApp,
				this.state.movetoPregSetup.showOnWeb!,
				this.state.movetoPregSetup.showOnApp!,
			),
		);

		return formRows;
	}

	private cycleDaysFromDateChanged = (newNumber: number | undefined) =>
		this.valueInMoveToPregnantSetupChanged(newNumber, 'cycleDaysFrom');
	private cycleDaysToDateChanged = (newNumber: number | undefined) =>
		this.valueInMoveToPregnantSetupChanged(newNumber, 'cycleDaysTo');
	private valueInMoveToPregnantSetupChanged(value: any, key: keyof IMoveToPregnancyLocation) {
		this.setState(prevState => ({
			movetoPregSetup: {
				...prevState.movetoPregSetup,
				[key]: value,
			},
		}));
	}

	private getBuildingHeader(): FormRow {
		return {
			header: localized(this.props.workListType),
		};
	}

	private getAnimalToListRow(): FormRow {
		return {
			name: localized('chooseAnimalToList'),
			component: (
				<SkioldFormDropdown
					items={this.state.options}
					selectedValue={this.state.selectedOption}
					onValueChanged={this.animalToListChanged}
				/>
			),
		};
	}

	private animalToListChanged = (option: Option) => {
		this.setState(prevState => ({
			movetoPregSetup: {
				...prevState.movetoPregSetup,
				selectedType: option.value as MoveToLocationTypes,
			},
			selectedOption: option,
		}));
	};

	private getFeedCurves(): FormRow {
		return {
			name: (
				<ViewWeb className="multiple-row-container">
					<TextWeb className="bold-font-size-sixteen">{localized('chooseFeedCurve')}:</TextWeb>
					<TextWeb className="bold-font-size-sixteen">{localized(AnimalKind.YoungFemale)}</TextWeb>
					<TextWeb className="bold-font-size-sixteen">{localized(AnimalKind.Gilt)}</TextWeb>
					<TextWeb className="bold-font-size-sixteen">{localized(AnimalKind.Sow)}</TextWeb>
				</ViewWeb>
			),
			component: (
				<ViewWeb className="curve-picker-container">
					<ViewWeb className="dummy-filler"></ViewWeb>
					<ViewWeb className="align-picker">
						<this.FeedCurvePicker animalKind={AnimalKind.YoungFemale} />
					</ViewWeb>
					<ViewWeb className="align-picker">
						<this.FeedCurvePicker animalKind={AnimalKind.Gilt} />
					</ViewWeb>
					<ViewWeb className="align-picker">
						<this.FeedCurvePicker animalKind={AnimalKind.Sow} />
					</ViewWeb>
				</ViewWeb>
			),
			style: { height: 170 },
		};
	}

	private FeedCurvePicker = (props: { animalKind: AnimalKind }) => {
		const curveChanged = (option: Option) => {
			this.setState(prevState => {
				let movetoPregSetup = deepCopy(prevState.movetoPregSetup);
				if (!movetoPregSetup.defaultFeedCurves) {
					movetoPregSetup.defaultFeedCurves = [];
				}

				let splitValue = option.value.split('-');
				const feedCurveNumber = splitValue.length > 1 ? parseInt(splitValue[1]) : undefined;
				const locationCode = splitValue.length > 1 ? splitValue[0] : undefined;

				if (
					movetoPregSetup.defaultFeedCurves.findIndex(curve => curve.animalKind === props.animalKind) === -1
				) {
					movetoPregSetup.defaultFeedCurves.push(
						new DefaultFeedCurve({
							animalKind: props.animalKind,
							feedCurveNumber: feedCurveNumber,
							locationCode: locationCode,
						}),
					);
				} else {
					movetoPregSetup.defaultFeedCurves = movetoPregSetup.defaultFeedCurves.map(defaultCurve =>
						defaultCurve.animalKind === props.animalKind
							? new DefaultFeedCurve({
									...defaultCurve,
									feedCurveNumber: feedCurveNumber,
									locationCode: locationCode,
							  })
							: defaultCurve,
					);
				}

				return { movetoPregSetup };
			});
		};

		const options = this.props.useEsf
			? this.props.feedCurvesOptions
			: this.props.feedCurvesOptions.filter(curve => filterElistarFeedCurvesByAnimalKind(curve, props.animalKind));

		return (
			<SkioldFormDropdown
				items={options}
				theme={'dark'}
				containerClassName="grade-dropdown"
				selectedValue={
					this.state.movetoPregSetup.defaultFeedCurves
						? this.renderOption(
								this.state.movetoPregSetup.defaultFeedCurves.find(
									defaultCurve => defaultCurve.animalKind === props.animalKind,
								),
						  )
						: { label: '', value: '' }
				}
				onValueChanged={curveChanged}
			/>
		);
	};

	private getNegativeCycleDaysRow(): FormRow {
		return {
			name: localized('cycleDaysShownNegative'),
			component: (
				<ViewWeb className="two-checkbox-container">
					<SkioldCheckbox
						onClick={this.SetNegativeCycleDaysToTrue}
						isChecked={this.state.movetoPregSetup.negativeCycleDays}
					/>
					<TextWeb>{localized('True')}</TextWeb>
					<SkioldCheckbox
						onClick={this.SetNegativeCycleDaysToFalse}
						isChecked={this.state.movetoPregSetup.negativeCycleDays ? false : true}
					/>
					<TextWeb>{localized('False')}</TextWeb>
				</ViewWeb>
			),
		};
	}

	private SetNegativeCycleDaysToFalse = () => {
		this.setState(prevState => ({
			movetoPregSetup: {
				...prevState.movetoPregSetup,
				negativeCycleDays: false,
			},
		}));
	};

	private SetNegativeCycleDaysToTrue = () => {
		this.setState(prevState => ({
			movetoPregSetup: {
				...prevState.movetoPregSetup,
				negativeCycleDays: true,
			},
		}));
	};

	private getWorkListSetting(type: WorkListType) {
		let workListSetting = this.props.workListSettings.find(
			setting => setting.type === type,
		) as MoveToPregnancyLocation;
		if (!workListSetting) {
			workListSetting = MoveToPregnancyLocation.fromJS({ type, showOnApp: true });
		}
		return workListSetting;
	}

	private renderButtons() {
		let buttons = (
			<ViewWeb className="buttons-container">
				<SkioldButton title={localized('Save')} onPress={() => this.save()} />
			</ViewWeb>
		);

		return buttons;
	}

	private renderOption = (defaultCurve: DefaultFeedCurve | undefined) => {
		if (defaultCurve) {
			const curve = this.props.feedCurvesOptions.find(
				curve =>
					defaultCurve.feedCurveNumber !== undefined &&
					defaultCurve.feedCurveNumber !== null &&
					curve.value === defaultCurve.locationCode + '-' + defaultCurve.feedCurveNumber.toString(),
			);

			if (curve) {
				return curve;
			}
		}
		return { label: '', value: '' };
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(MoveToPregnantSetup);
